// This component may seem like a unnecessary abstraction, but it helps prevent rerenders loops.

import React from "react";
import { CommandCenterSection } from "../models/CommandCenterSection";
import CommandCenterColumnView from "./CommandCenterColumnView";
import { CommandProjectInfo } from "./CommandTypes";

type ColumnContainerProps = {
    projectInfo: CommandProjectInfo;
    commandCenterSection: CommandCenterSection | undefined;
};

const ColumnContainer: React.FC<ColumnContainerProps> = ({ projectInfo, commandCenterSection }) => {
    if (!commandCenterSection?.enabled || !commandCenterSection.sectionConfig?.length) {
        return null;
    }

    return <CommandCenterColumnView projectInfo={projectInfo} commandCenterSection={commandCenterSection} />;
};

export default ColumnContainer;
